import React from "react";
import { Row, Col, Button, Modal, Form, Container } from "react-bootstrap";
import t from "tcomb-form";
import "./AddSupportUsers.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class AddSupportUsers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: {
        fName: "",
        lName: "",
        dsgntn: "",
        email: "",
        mob: "",
        isHidden: false,
      },
      isHidden: true,
      emailError: "",
      mobError: "",
      fNameError: "",
      lNameError: "",
      dsgntnError: "",
    };
  }

  onChange = e => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === "fName") {
      this.setState({
        value: { ...this.state.value, fName: value },
        fNameError:""
      });
    } else if (name === "lName") {
      this.setState({ value: { ...this.state.value, lName: value },lNameError:""
       });
    } else if (name === "dsgntn") {
      this.setState({ value: { ...this.state.value, dsgntn: value }, dsgntnError:"" });
    } else if (name === "email") {
      this.setState({ value: { ...this.state.value, email: value } , emailError:""});
    } else if (name === "mob") {
      this.setState({ value: { ...this.state.value, mob: value }, mobError:"" });
    }
  };

  validate = () => {
    let isError = false;
    let regexemail = /^\S+@\S+\.\S+$/;
    let regexcode = /^[7-9][0-9]{9}$/;

    const errmsg1 = "Enter a valid input";
    const errmsg2 = "This is a mandatory field";
   
    const errors = {
      emailError: "",
      mobError: "",
      fNameError: "",
      lNameError: "",
      dsgntnError: "",
    };

    if (this.state.value.fName === "") {
      isError = true;
      errors.fNameError = errmsg2;
    }
    if (this.state.value.lName === "") {
      isError = true;
      errors.lNameError = errmsg2;
    }
    if (!regexemail.test(this.state.value.email)) {
      isError = true;
      errors.emailError = errmsg1;
    }
    if (this.state.value.email === "") {
      isError = true;
      errors.emailError = errmsg2;
    }
    if (this.state.value.mob === "") {
      isError = true;
      errors.mobError = errmsg2;
    }
    if (
      this.state.value.mob !== "" &&
      !regexcode.test(this.state.value.mob)
    ) {
      isError = true;
      errors.mobError = errmsg1;
    }
    if (this.state.value.dsgntn === "") {
      isError = true;
      errors.dsgntnError = errmsg2;
    }
    this.setState({
      ...this.state,
      ...errors,
    });

    return isError;
  };

  submit=() =>{
    const err = this.validate();
    if (!err) {
      this.props.addSupportUsers(this.state.value);
      this.setState({
        value: {
          fName: "",
          lName: "",
          dsgntn: "",
          email: "",
          mob: "",
          isHidden: false,
        },
        isHidden: true,
        emailError: "",
        mobError: "",
        fNameError: "",
        lNameError: "",
        dsgntnError: "",
      });
      this.props.handleClose();
      this.props.resetPage();
    } 
  };

  closeModal=()=> {
    this.setState({
      value: {
        fName: "",
        lName: "",
        dsgntn: "",
        email: "",
        mob: "",
        isHidden: false,
      },
      isHidden: true,
      emailError: "",
      mobError: "",
      fNameError: "",
      lNameError: "",
      dsgntnError: "",
    });
    this.props.handleClose();
  }

  render() {
   return (
      <div>
        <Modal
          show={this.props.ShowAddModel}
          onHide={this.closeModal}
          animation={false}
          size="lg"
          backdrop="static"
        >
          <Modal.Header
             style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
             closeButton
          >
            <Modal.Title>Add Support User</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Form>
                <Row>
                <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="fName">
                      <Form.Label className="mandatoryField">
                        First Name
                      </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="fName"
                        value={this.state.value.fName}
                        onChange={this.onChange}
                      />
                       <div className="errStyle">{this.state.fNameError}</div>
                    </Form.Group>
                  </Col>

                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="lName">
                      <Form.Label className="mandatoryField">
                        Last Name
                      </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="lName"
                        value={this.state.value.lName}
                        onChange={this.onChange}
                      />
                       <div className="errStyle">{this.state.lNameError}</div>
                    </Form.Group>
                  </Col>

                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="dsgntn">
                      <Form.Label className="mandatoryField">
                       Designation
                      </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="dsgntn"
                        value={this.state.value.dsgntn}
                        onChange={this.onChange}
                      />
                       <div className="errStyle">{this.state.dsgntnError}</div>
                    </Form.Group>
                  </Col>

                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="email">
                      <Form.Label className="mandatoryField">
                       Email ID
                      </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="email"
                        value={this.state.value.email}
                        onChange={this.onChange}
                      />
                      <div className="errStyle">{this.state.emailError}</div>
                    </Form.Group>
                  </Col>

                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="mob">
                      <Form.Label className="mandatoryField">
                       Mobile Number
                      </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="mob"
                        value={this.state.value.mob}
                        onChange={this.onChange}
                      />
                       <div className="errStyle">{this.state.mobError}</div>
                    </Form.Group>
                  </Col>
                  
                </Row>
              </Form>
            </Container>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}>

            <Button
              type="submit"
              className="SupportUsersbtnSubmit"
              onClick={this.submit}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default AddSupportUsers;
